import $ from 'jquery';
import Cookies from 'js-cookie';
import Modernizr from 'modernizr';
import Cache from "@utils/Cache";

class App {
    constructor() {

    }

    defineSplCalcSliderAnimationJqueryPlugin() {
        //SPL calc
        $.fn.animateSplCalcSlider = function(opts) {

            $.extend({
                dataSelector: 'plugin_loanCalc'
            }, opts);

            var calc = $(this).data(opts.dataSelector);

            var min = calc.getMinLoanAmount();
            var max = calc.getMaxLoanAmount();
            var starting = calc.getStartingLoanAmount();
            var step = calc.settings.sliderStep;
            var queue = [];

            if(step == 100) {
                step = step * 2;
                // } else if(step == 200 || step == 300) {
            }

            var num = min;
            while (num <= max) {
                queue.push(num);
                num = num + step;
            }

            if (num != max) {
                queue.push(max);
            }

            num = max;
            num = max - step;
            while (num >= starting) {
                queue.push(num);
                num = num - step;
            }

            if (num != starting) {
                queue.push(starting);
            }

            // console.log(queue);

            queue.reverse();

            var executeNext = function (num)  {
                var delay = 10;
                calc.$loanAmount.val(num).trigger('change');
                if(num == max) {
                    delay = 700;
                }
                setTimeout(function () {
                    if (queue.length > 0) {
                        executeNext(queue.pop());
                    }

                }, delay);
            };

            if (queue.length > 0) {
                executeNext(queue.pop());
            }

            return $(this);
        };
    }

    defineInstCalcSliderAnimationJqueryPlugin() {

        //INST calc animation
        $.fn.animateInstCalcSlider = function(opts) {

            $.extend({
                dataSelector: 'plugin_instLoanCalc'
            }, opts);

            var calc = $(this).data(opts.dataSelector);

            var min = calc.getMinLoanAmount();
            var max = calc.getMaxLoanAmount();
            // var minMonth = calc.getMinInstallmentCount();
            var minMonth = calc.getStartingInstallmentCount() - 1;
            // var maxMonth = calc.getMaxInstallmentCount();
            var maxMonth = calc.getStartingInstallmentCount();
            var starting = calc.getStartingLoanAmount();
            var step = calc.settings.sliderStep;
            var queue = [];
            var monthQueue = [];

            if(step == 100 || step ==200) {
                step = step * 5;
            } else if(step == 500 || step == 1000) {
                step = step * 2;
            }

            var num = min;
            while (num <= max) {
                queue.push(num);
                num = num + step;
            }

            var mNum = minMonth;
            while (mNum <= maxMonth) {
                monthQueue.push(mNum);
                mNum++;
            }

            if (num != max) {
                queue.push(max);
            }

            if (mNum != maxMonth) {
                monthQueue.push(maxMonth);
            }

            num = max;
            num = max - step;
            while (num >= starting) {
                queue.push(num);
                num = num - step;
            }

            if (num != starting) {
                queue.push(starting);
            }

            queue.reverse();
            monthQueue.reverse();

            var executeNext = function (num)  {
                var delay = 10;
                // console.log(num);
                calc.$loanAmount.val(num).trigger('change');
                if(num == max) {
                    // console.log('set delay');
                    delay = 1000;
                }
                setTimeout(function () {
                    if (queue.length > 0) {
                        executeNext(queue.pop());
                    }

                }, delay);
            };

            var executeNextMonth = function (monthNum)  {
                var delay = 100;
                // console.log(monthNum);
                calc.$installmentCount.val(monthNum).trigger('change');

                setTimeout(function () {
                    if (monthQueue.length > 0) {
                        executeNextMonth(monthQueue.pop());
                    }

                }, delay);
            };

            if (queue.length > 0) {
                executeNext(queue.pop());
            }

            if (monthQueue.length > 0) {
                executeNextMonth(monthQueue.pop());
            }

            return $(this);
        };
    }

    bindAppEvents() {

        /**
         * The ready event occurs after the HTML document has been loaded, while the onload event occurs later, when all
         * content (e.g. images) also has been loaded.
         */
        $(window).on('load', () => {
            footer();
            fixed_chat_btn();
            position_popup();

            sidemenu_dt_follow_track();
            //contacts_cols();
            sameheight_twocol_elements();
        });

        $(window).on('scroll', () => {
            fixed_chat_btn();
            position_popup();
            sidemenu_dt_follow_track();

            var l=$('html').scrollLeft();
            if(l<=0)l=$('body').scrollLeft();

            if(l>0)
            {
                $('html,body').scrollLeft(0);
            }
        });

        $(window).on('resize', () => {
            footer();
            fixed_chat_btn();
            position_popup();
            sidemenu_dt_follow_track();

            if(_v!=ver())
            {
                _v=ver();
                $(window).trigger('versionchange');
            }
        });

        $(window).on('versionchange',function(){
            mobmenu_check();
            //contacts_cols();
            sameheight_twocol_elements();
        });


        $(() => {
            /*default script snippets*//*iphone delegation*/
            // $('*').on('click', function () {
            // });
            /*email _at_ replace*/
            $('a[href*="mailto"]').each(function () {
                var t = $(this), n = t.attr('href').replace('_at_', '@'), m = t.html().replace('_at_', '@');
                t.attr('href', n).html(m);
            });
            /*empty links disable*/
            $('[href="#"]').on('click', function (e) {
                e.preventDefault();
            });
            /*data-goto*/
            $('[data-goto]').on('click', function (e) {
                e.preventDefault();
                if ($('#' + $(this).data('goto')).length) $('html,body').stop(true).animate({'scrollTop': $('#' + $(this).data('goto')).first().offset().top + 'px'}, 400);
            });
            /*ios select instant change fix*/
            if (ios) $('select').append('<optgroup disabled="disabled"></optgroup>');
            /*iOS10+DisableZoom*/
            document.addEventListener('touchmove', function (e) {
                if (e.scale !== 1) {
                    e.preventDefault();
                }
            }, false);
            var _lastTouchEnd = 0;
            document.addEventListener('touchend', function (e) {
                var now = (new Date()).getTime();
                if (now - _lastTouchEnd <= 300) {
                    e.preventDefault();
                }
                _lastTouchEnd = now;
            }, false);

            _v=ver();
            //scrollbar width test
            $('body').append('<div id="scrollbar_test_outer" style="overflow-y:scroll;position:absolute;top:-9999px;left:-9999px;"><div id="scrollbar_test_inner"></div></div>');
            scrollbar_width=$('#scrollbar_test_outer').width()-$('#scrollbar_test_inner').width();
            $('#scrollbar_test_outer').remove();

            if(typeof(Modernizr)!='undefined')
            {
                if(!Modernizr.svg)
                {$('.decide_svg').each(function(){$(this).attr('src',$(this).data('src')).removeClass('decide_svg');});}
                else
                {$('.decide_svg').each(function(){$(this).attr('src',$(this).data('svgsrc')).removeClass('decide_svg');});}
            }
            if(ios)$('html').addClass('ios');
            if(mobile)$('html').addClass('mobile');

            /**
             * Cookies term approve
             */
            var cookiesBlock = $('.cookies_block:not(.trans)');
            if(cookiesBlock.length) {
                if ( !Cookies.get('accept_cookie_terms') ) {
                    cookiesBlock.slideDown(200);
                    cookiesBlock.removeClass('hidden');
                    cookiesBlock.find('.close_cookies').on("click", function () {
                        Cookies.set('accept_cookie_terms', {'approved':true} , { expires: 365 });
                        cookiesBlock.slideUp(400);
                    });
                } else {
                    cookiesBlock.remove();
                }
            }

            $.fn.loadify=function(options){

                var defaults={
                    callback:function(){}
                };

                var settings=$.extend(true,{},defaults,options);

                this.on('click', function(){
                    var tr=$(this),c=$(tr.data('loadify-container'));
                    if(!c.hasClass('has_loader_overlay'))
                    {
                        if(c.css('position')=='static')
                        {
                            c.css('position','relative');
                        }
                        c.addClass('has_loader_overlay').prepend('<div class="loader_overlay"></div>');
                    }
                    settings.callback(tr,c);
                });
                return this;
            };

            init_custom_content();
            sidemenu_dt_follow_track();
            //contacts_cols();
            sameheight_twocol_elements();
            init_content();
            popup_stuff();
            footer();
            fixed_chat_btn();
            position_popup();
            menuItemsDropDownLink();
            mobileSubmenus();
        });
    }

    bindLogoutClick(){
        $(() => {
            $(document).on('click', '.logout-link', function (e) {
                e.preventDefault();
                var href = $(this).attr('href');
                window.location = href;
            });
        });
    }
    init() {
        ENV === 'development' && console.log('App::init()');

        // Delete all saved cache.
        Cache.invalidateAll();

        this.bindAppEvents();
        //this.bindLogoutClick();
    }
}

export default App;
